export const alphabeticalSort = (key) => (sorted) => (a, b) => {
  let valA, valB;
  if (!Array.isArray(key)) {
    [valA, valB] = [a[key], b[key]];
  } else {
    [valA, valB] = [getFirstExistingValue(key, a), getFirstExistingValue(key, b)];
  }

  return (valA || '').toString().localeCompare((valB || '').toString()) * (sorted ? 1 : -1);
};

export const booleanSort =
  (transformFunc = (val) => val) =>
  (sorted) =>
  (a, b) =>
    transformFunc(a) === transformFunc(b) ? 0 : !!transformFunc(a) ? (sorted ? -1 : 1) : sorted ? 1 : -1;

export const valueSort = (key) => (sorted) => (a, b) => (a[key] - b[key]) * (sorted ? -1 : 1);

function getFirstExistingValue(keys, target) {
  return keys.reduce((a, c) => (!!a ? a : target[c]), '');
}
